import CountdownTimer from '@pixelunion/pxs-countdown-timer';
import ProductItem from '../components/ProductItem';
import Parallax from '../components/Parallax';

export default class DynamicCountdownTimer {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;
    new CountdownTimer(this.el);
    this.parallax = this.settings.parallax;
    this.imageEl = this.el.querySelector('.countdown-timer__image-element');
    this.imageContainerEl = this.el.querySelector('.countdown-timer__image');
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }

    if (this.parallax && this.imageEl) {
      this.parallaxObject = new Parallax({
        img: this.imageEl,
        container: this.imageContainerEl,
        isVisible: () => true,
      });
    }
  }

  onSectionUnload() {
    this.products.forEach(product => product.unload());

    if (this.parallax && this.imageEl) {
      this.parallaxObject.unload();
      this.parallaxObject = null;
    }
  }
}
